import { render, staticRenderFns } from "./MiraDetailCard.vue?vue&type=template&id=126aa71e&scoped=true&"
import script from "./MiraDetailCard.vue?vue&type=script&lang=ts&"
export * from "./MiraDetailCard.vue?vue&type=script&lang=ts&"
import style0 from "./MiraDetailCard.vue?vue&type=style&index=0&id=126aa71e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126aa71e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
